import { useEffect, useRef, useState } from 'react';

const ITEMS_PER_PAGE = 5;

const useCarouselState = () => {
  const carouselRef = useRef<HTMLDivElement>(null);
  const [isFirstItemVisible, setIsFirstItemVisible] = useState(true);
  const [isLastItemVisible, setIsLastItemVisible] = useState(false);

  useEffect(() => {
    const { current } = carouselRef;
    if (current) {
      current.addEventListener('scroll', handleScroll);
    }
    return () => {
      if (current) {
        current.removeEventListener('scroll', handleScroll);
      }
    };
  }, [carouselRef]);

  const handleScroll = () => {
    if (carouselRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = carouselRef.current;
      setIsFirstItemVisible(scrollLeft === 0);
      setIsLastItemVisible(scrollLeft + clientWidth >= scrollWidth - 10);
    }
  };

  const scrollRight = () => {
    if (carouselRef.current) {
      const itemWidth = carouselRef.current.clientWidth / ITEMS_PER_PAGE;
      carouselRef.current.scrollLeft += itemWidth * ITEMS_PER_PAGE;
    }
  };

  const scrollLeft = () => {
    if (carouselRef.current) {
      const itemWidth = carouselRef.current.clientWidth / ITEMS_PER_PAGE;
      carouselRef.current.scrollLeft -= itemWidth * ITEMS_PER_PAGE;
    }
  };

  return {
    carouselRef,
    isFirstItemVisible,
    isLastItemVisible,
    scrollRight,
    scrollLeft,
  };
};

export { useCarouselState };
